"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBarMenuButton = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("design_system/Icon");
var _MenuButton = require("design_system/Menu/MenuButton");
var _useResizeObserver = require("design_system/hooks/useResizeObserver");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  text: "text-white",
  position: "flex items-center",
  focus: "focus:outline-none focus:underline",
  hover: "hover:underline",
  chevron: "mr-4"
};
const TopBarMenuButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    narrowIcon,
    narrowAriaLabel,
    className,
    ...props
  } = _ref;
  const [width] = (0, _useResizeObserver.useResizeObserver)();
  const shouldUseNarrowVersion = narrowIcon && width < _useResizeObserver.BREAKPOINTS.s768;
  return /*#__PURE__*/_react.default.createElement(_MenuButton.MenuButton, _extends({
    ref: ref,
    text: THEME.text,
    focus: shouldUseNarrowVersion ? undefined : THEME.focus,
    hover: THEME.hover,
    className: (0, _classnames.default)(THEME.position, className),
    role: "menuitem",
    "aria-label": shouldUseNarrowVersion ? narrowAriaLabel : undefined
  }, props), shouldUseNarrowVersion ? /*#__PURE__*/(0, _react.cloneElement)(narrowIcon, {
    "aria-hidden": true
  }) : children, /*#__PURE__*/_react.default.createElement(_Icon.ChevronDown, {
    size: 16,
    className: THEME.chevron
  }));
});
exports.TopBarMenuButton = TopBarMenuButton;
TopBarMenuButton.displayName = "TopBar.MenuButton";